"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserRole = exports.isNewUser = void 0;
var isNewUser = function isNewUser(idToken) {
  try {
    var decodedTokenPayload = JSON.parse(atob(idToken.split('.')[1]));
    return !!decodedTokenPayload.newUser;
  } catch (_) {
    return false;
  }
};
exports.isNewUser = isNewUser;
var getUserRole = function getUserRole(idToken) {
  try {
    var decodedTokenPayload = JSON.parse(atob(idToken.split('.')[1]));
    return decodedTokenPayload.jobTitle;
  } catch (_) {
    return undefined;
  }
};
exports.getUserRole = getUserRole;
//# sourceMappingURL=index.js.map